import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=6fb47258&scoped=true&"
import script from "./Terminos.vue?vue&type=script&lang=js&"
export * from "./Terminos.vue?vue&type=script&lang=js&"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=6fb47258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb47258",
  null
  
)

export default component.exports